<app-dialog [config]="createModifyDimensionValueConditionsConfig"></app-dialog>
